import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert, AlertModule, AlertService, AlertType, EmptyStateModule, TableConfig, TableModule } from '@michelin/theme';
import { Subscription } from 'rxjs';
import { Applications } from '../interfaces/application';
import { UtilService } from '../util/util.service';

import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { ApplicationsAddModalComponent } from './applications-add-modal/applications-add-modal.component';
import { ApplicationsDeleteComponent } from './applications-delete/applications-delete.component';
import { ApplicationsModalComponent } from './applications-modal/applications-modal.component';
import { ApplicationsService } from './applications.service';

@Component({
  selector: 'mic-app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss'],
  imports: [TableModule, NgClass, MatIcon, MatMenuItem, EmptyStateModule, MatButton, AlertModule]
})
export class ApplicationsComponent implements OnInit {
  private readonly applicationService = inject(ApplicationsService);
  dialog = inject(MatDialog);
  private readonly alertService = inject(AlertService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  util = inject(UtilService);
  private readonly cdr = inject(ChangeDetectorRef);

  isFetching = true;

  applications: Applications[];
  subscription: Subscription;

  lazyApplications: Applications[];
  dataSource = new MatTableDataSource();

  private fetchData() {
    this.isFetching = true;
    this.applicationService.getApplications().subscribe((response) => {
      this.applications = response;
      this.dataSource.data = this.applications;
      this.isFetching = false;
      this.cdr.detectChanges();
    });
  }
  ngOnInit(): void {
    this.applicationService.getLazyApplications().subscribe((response) => {
      this.lazyApplications = response;
      this.dataSource.data = this.lazyApplications;
      this.cdr.detectChanges();
    });
  }

  tableConfig: TableConfig<Applications> = {
    columns: {
      name: { cell: (elm: Applications) => elm.name.toString(), header: 'Name' },
      status: { cell: 'status', header: 'Status' }
    }
  };

  remove(element: Applications) {
    const dialogRef = this.dialog.open(ApplicationsDeleteComponent, {
      width: '400px',
      data: element
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.ngOnInit();
        this.deleteAlert(element);
      }
    });
  }

  details(element: Applications) {
    this.applicationService.myObject = element;
    this.router.navigate([element.name], { relativeTo: this.route });
  }

  // Open a modal
  onClick(tableRow: Applications): void {
    const dialogRef = this.dialog.open(ApplicationsModalComponent, {
      width: '400px',
      data: tableRow
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.ngOnInit();
        this.businessTask(tableRow, 'updated');
      }
    });
  }

  deleteAlert(application: Applications): void {
    // the alert when we delete the user
    this.alertService.showAlert({
      type: AlertType.clear,
      content: `The application : ${application.name} has been successfully deleted ! `
    } as Alert);
  }

  businessTask(application: Applications, etat: string): void {
    // Do a business task
    this.alertService.showAlert({
      type: AlertType.classical,
      content: `The application : ${application.name} has been successfully ${etat} ! `
    } as Alert);
  }

  onAddApplication() {
    const dialogRef = this.dialog.open(ApplicationsAddModalComponent, {
      width: '400px',
      data: { name: 'test' }
    });
    dialogRef.afterClosed().subscribe((result: Applications) => {
      if (result != null) {
        this.ngOnInit();
        this.businessTask(result, 'added');
      }
    });
  }
}
